import { Controller } from "stimulus"
import _ from 'lodash';

const STICKY_ELEMENT_CLASS = '.sticky-element';

export default class extends Controller {
  static targets = [
    'stuck',
    'fadeTrigger',
    'fadeIn',
    'fadeOut'
  ]

  connect() {
    window.addEventListener('scroll', _.throttle(() => {
      this.stick();
    }), 2000);
    this.stick();
  }

  stick() {
    this.stuckTargets.forEach(e => {
      const disableStickyQuery = e.getAttribute('data-disable-sticky-query');
      const stickyDisabled = window.matchMedia(disableStickyQuery).matches;
      if (!stickyDisabled) {
        const offsetFromTop = this.getExistingStickyHeight(e);
        e.style.top = `${offsetFromTop}px`;
      }
    })
    const disableFadeQuery = this.element.getAttribute('data-disable-fade-query');
    const fadeDisabled = window.matchMedia(disableFadeQuery).matches;

    if (!fadeDisabled && this.hasFadeOutTarget && this.hasFadeInTarget && this.hasFadeTriggerTarget) {
      const { y } = this.fadeOutTarget.getBoundingClientRect();
      const { y: elementY, height: elementHeight } = this.fadeTriggerTarget.getBoundingClientRect();
      if (y < (elementY + elementHeight)) {
        this.fadeInTarget.style.display = 'flex';
        const offset = elementY + elementHeight - y;
        this.fadeOutTarget.style.opacity = Math.max(0, 1 - (offset / (elementY + elementHeight) * 3));
        this.fadeInTarget.style.opacity = Math.min(1, (offset / (elementY + elementHeight) * 3));
      } else {
        this.fadeInTarget.style.display = 'none';
        this.fadeOutTarget.style.opacity = 1;
        this.fadeInTarget.style.opacity = 0;
      }
    } else {
      if (this.hasFadeInTarget) {
        this.fadeInTarget.style.display = 'none';
      }
    }
  }

  getExistingStickyHeight(element) {
    // Get Nav Height to offset sticky position
    const navs = document.querySelectorAll(STICKY_ELEMENT_CLASS);
    let totalOffsetHeight = 0;
    navs.forEach(e => {
      const elementPositionProperty = getComputedStyle(e)['position'];
      if (e.offsetParent != null && elementPositionProperty == 'sticky') {
        const { height } = e.getBoundingClientRect();
        totalOffsetHeight += height;
      }
    })

    // Priority of Sticky Level (order of sticky elements)
    const stickyIndex = parseInt(element.getAttribute('data-sticky-index'));
    // Get other sticky elements' height to offset sticky position
    const otherStickyTargets = this.element.querySelectorAll('[data-sticky-index]')
    otherStickyTargets.forEach(e => {
      const otherStickyIndex = parseInt(e.getAttribute('data-sticky-index'));
      if (otherStickyIndex < stickyIndex) {
        const { height } = e.getBoundingClientRect();
        totalOffsetHeight += height;
      }
    })
    return totalOffsetHeight;
  }
}
